// extracted by mini-css-extract-plugin
export default {"fruitBox":"fiberFruits_fruitBox__Jle-x","fruitBoxImage":"fiberFruits_fruitBoxImage__-K9ZI","fruitBoxInfo":"fiberFruits_fruitBoxInfo__O2dyh"};